import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
interface IProps {
  value: string;
  setfeildValue: any;
}
const GlobalPhoneEditInput = ({ value, setfeildValue }: IProps) => {
  return (
    <>
      <PhoneInput
        country={"pk"}
        value={value}
        onChange={(phone) => setfeildValue(phone)}
        inputStyle={{
          width: "100%",

          height: "60px",

          fontSize: "13px",

          paddingLeft: "48px",

          borderRadius: "5px",
        }}
        buttonStyle={{ borderRadius: "5px 0 0 5px" }}
        dropdownStyle={{ width: "500px" }}
      />
    </>
  );
};
export default GlobalPhoneEditInput;
